import update from 'immutability-helper'
import {
  GET_BONUS_CHECKS_SUCCESS,
  HAS_BONUS_CHECK_SUPPORT_SUCCESS,
  REDEEM_BONUS_CHECK_SUCCESS,
  UPDATE_BONUS_CHECK,
  CLEAR_REDEEM_RESULT,
  CLEAR_BONUS_CHECKS,
} from '../actions/action-types'

const initialState = {
  hasBonusCheckSupport: false,
  bonusChecks: [],
  redeemResult: {},
}

// eslint-disable-next-line default-param-last
const bonusCheck = (state = initialState, action) => {
  switch (action.type) {
    case HAS_BONUS_CHECK_SUPPORT_SUCCESS:
      return update(state, {
        hasBonusCheckSupport: {
          $set: action.response.bonusCheckSupported,
        },
      })
    case GET_BONUS_CHECKS_SUCCESS:
      return update(state, {
        bonusChecks: {
          $set: action.response.bonusChecks ? action.response.bonusChecks : [],
        },
      })
    case UPDATE_BONUS_CHECK:
      return update(state, {
        bonusChecks: {
          $set: state.bonusChecks.map(c =>
            c.reference === action.response.reference ? action.response : c,
          ),
        },
      })
    case REDEEM_BONUS_CHECK_SUCCESS:
      return update(state, {
        redeemResult: {
          $set: action.response,
        },
      })
    case CLEAR_REDEEM_RESULT:
      return update(state, {
        redeemResult: {
          $set: {},
        },
      })
    case CLEAR_BONUS_CHECKS:
      return { ...initialState }
    default:
      return state
  }
}

export default bonusCheck
